/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EMainContact = 'EmailNotification' | 'Email' | 'Notification';

export const EMainContact = {
    EmailNotification: 'EmailNotification' as EMainContact,
    Email: 'Email' as EMainContact,
    Notification: 'Notification' as EMainContact
};

